export default "__VITE_ASSET__vU9JT25b__"